import React, { useEffect } from 'react';
import { View, StyleSheet } from 'react-native';
import { useTheme } from '../contexts/ThemeContext';

export default function LogoCarousel({ logos = [], speed = 40, logoSize = 120, logoSpacing = 60 }) {
  const { colors, isDark } = useTheme();
  
  console.log('🎠 LogoCarousel props:', { logos: logos.length, speed, logoSize, logoSpacing });

  useEffect(() => {
    // Inject custom animation duration, logo size, and spacing
    const styleId = 'carousel-custom-style';
    let styleEl = document.getElementById(styleId);
    
    if (!styleEl) {
      styleEl = document.createElement('style');
      styleEl.id = styleId;
      document.head.appendChild(styleEl);
    }
    
    styleEl.textContent = `
      @keyframes scroll {
        0% {
          transform: translateX(0);
        }
        100% {
          transform: translateX(-25%);
        }
      }
      .logo-carousel-wrapper {
        overflow: hidden !important;
        width: 100% !important;
        mask-image: linear-gradient(to right, transparent, black 10%, black 90%, transparent) !important;
        -webkit-mask-image: linear-gradient(to right, transparent, black 10%, black 90%, transparent) !important;
      }
      .logo-carousel-track {
        display: flex !important;
        flex-direction: row !important;
        gap: ${logoSpacing}px !important;
        animation: scroll ${speed}s linear infinite !important;
        will-change: transform !important;
      }
      .logo-carousel-item {
        width: ${logoSize}px !important;
        height: ${logoSize * 0.5}px !important;
        display: flex !important;
        justify-content: center !important;
        align-items: center !important;
        flex-shrink: 0 !important;
      }
      .logo-carousel-img {
        width: 100% !important;
        height: 100% !important;
        object-fit: contain !important;
        opacity: 0.7 !important;
        filter: grayscale(100%) !important;
        transition: all 0.3s ease !important;
      }
      .logo-carousel-img:hover {
        opacity: 1 !important;
        filter: grayscale(0%) !important;
        transform: scale(1.1) !important;
      }
    `;
    
    return () => {
      const el = document.getElementById(styleId);
      if (el) el.remove();
    };
  }, [speed, logoSize, logoSpacing]);

  // Fallback logos if none are loaded
  const defaultLogos = [
    { id: 'notion', name: 'Notion', url: 'https://upload.wikimedia.org/wikipedia/commons/4/45/Notion_app_logo.png' },
    { id: 'upwork', name: 'Upwork', url: 'https://upload.wikimedia.org/wikipedia/commons/2/24/Upwork_logo.svg' },
    { id: 'contra', name: 'Contra', url: 'https://contra.com/favicon.ico' }
  ];
  
  const displayLogos = logos.length > 0 ? logos : defaultLogos;

  // Duplicate logos multiple times for seamless infinite scroll
  const duplicatedLogos = [...displayLogos, ...displayLogos, ...displayLogos, ...displayLogos];

  return (
    <View style={styles.container}>
      <div className="logo-carousel-wrapper">
        <div className="logo-carousel-track">
          {duplicatedLogos.map((logo, index) => (
            <div key={`${logo.id}-${index}`} className="logo-carousel-item">
              <img
                src={logo.url}
                alt={logo.name}
                className="logo-carousel-img"
              />
            </div>
          ))}
        </div>
      </div>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: '100%',
    paddingVertical: 40,
    overflow: 'hidden',
  },
});
